// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.planeamento-page {
    display: flex;
    flex-direction: column;
    min-height: 100%;
}

.planeamento-container {
    display: flex;
    flex-direction: column;
    min-height: 100%;
}

.planeamento-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
}

.planeamento-header h1 {
    font-size: 24px;
    color: #2d3748;
    margin-bottom: 5px;
}

.planeamento-header p {
    color: #718096;
}

.gantt-container {
    display: flex;
    flex-direction: column;
    /* Headers on top, body below */
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
    border: 1px solid #e2e8f0;
    height: calc(100vh - 480px);
    min-height: 280px;
    overflow: hidden;
}

.gantt-sidebar-column {
    width: 250px;
    flex-shrink: 0;
    border-right: 2px solid #edf2f7;
    background: #f8fafc;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE/Edge */
    -webkit-overflow-scrolling: touch;
}

.gantt-sidebar-column::-webkit-scrollbar {
    display: none;
    /* Chrome/Safari */
}

/* Obsolete classes override/cleanup */
.gantt-main,
.gantt-sidebar {
    display: none;
}

.gantt-sidebar-header {
    width: 250px;
    /* IMPORTANT: Match sidebar text column width */
    height: 80px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    padding: 0 20px;
    font-weight: 700;
    color: #4a5568;
    border-bottom: 2px solid #edf2f7;
    background: #f8fafc;
    border-right: 2px solid #edf2f7;
    /* Add border to match column */
    box-sizing: border-box;
}

.gantt-row-label {
    height: 38px;
    /* Force fixed height to match content rows */
    flex-shrink: 0;
    display: flex;
    align-items: center;
    padding: 0 10px;
    border-bottom: 1px solid #edf2f7;
    box-sizing: border-box;
    overflow: hidden;
    font-size: 13px;
}

.obra-info {
    display: flex;
    flex-direction: column;
}

.obra-info strong {
    font-size: 11px;
    margin-bottom: 2px;
}

.obra-info small {
    font-size: 9px;
}

.obra-dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    display: inline-block;
    margin-bottom: 5px;
}

.gantt-timeline-wrapper {
    flex-grow: 1;
    overflow-x: auto;
    position: relative;
    background: white;
    -webkit-overflow-scrolling: touch;
}

.gantt-timeline-header {
    display: flex;
    height: 40px;
    border-bottom: 1px solid #edf2f7;
    background: #ebf4ff;
}

.gantt-timeline-month {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 700;
    color: #2c5282;
    border-right: 3px solid #2b6cb0;
    text-transform: capitalize;
    box-sizing: border-box;
}

.gantt-timeline-month:nth-child(even) {
    background: #dbeafe;
}

.gantt-timeline-month:nth-child(odd) {
    background: #eff6ff;
}

.gantt-timeline-days {
    display: flex;
    height: 40px;
    border-bottom: 2px solid #edf2f7;
}

.gantt-day-cell {
    width: 40px;
    min-width: 40px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #718096;
    border-right: 1px solid #cbd5e0;
}

.gantt-day-cell.weekend {
    background-color: #f7fafc;
}

.gantt-day-cell.today {
    background-color: #fff5f5;
    color: #e53e3e;
    position: relative;
}

.gantt-day-cell.today::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: #e53e3e;
}

.gantt-day-cell.month-end,
.gantt-cell.month-end {
    border-right: 2px solid #2b6cb0;
}

.gantt-day-cell.week-start {
    border-left: 2px solid #94a3b8;
}

.gantt-week-line {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 2px;
    background: #94a3b8;
    pointer-events: none;
    z-index: 1;
}

/* Semana seleccionada no painel: faixa no corpo + destaque no header */
.gantt-selected-week {
    position: absolute;
    top: 0;
    bottom: 0;
    background: rgba(49, 130, 206, 0.07);
    border-left: 2px solid #3182ce;
    border-right: 2px solid #3182ce;
    pointer-events: none;
    z-index: 2;
}
.gantt-day-cell.selected-week {
    background-color: rgba(49, 130, 206, 0.12);
    color: #2b6cb0;
    font-weight: 700;
}
.gantt-day-cell.selected-week.today { background-color: #fed7d7; color: #c53030; }

.gantt-row-content {
    height: 38px;
    /* Force fixed height for alignment */
    flex-shrink: 0;
    position: relative;
    border-bottom: 1px solid #edf2f7;
    box-sizing: border-box;
    user-select: none;
    background-image: repeating-linear-gradient(
        to right,
        transparent 0px,
        transparent 39px,
        #cbd5e0 39px,
        #cbd5e0 40px
    );
    background-size: 40px 100%;
}

.gantt-cell {
    width: 40px;
    min-width: 40px;
    height: 100%;
    border-right: 1px solid #cbd5e0;
    flex-shrink: 0;
    position: relative;
    /* Para z-index funcionar */
    z-index: 20;
    /* Ficar por cima da barra */
    pointer-events: none;
    /* Deixar cliques passarem para a barra em baixo */
    background: transparent;
    user-select: none;
    cursor: default;
}

.gantt-cell.weekend {
    background-color: rgba(247, 250, 252, 0.6);
    /* Transparente para ver a barra por baixo */
}

.gantt-bar-obra {
    position: absolute;
    height: 18px;
    /* Slightly thinner */
    top: 10px;
    /* Repositioned for center */
    border-radius: 4px;
    color: white;
    display: flex;
    align-items: center;
    padding: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    z-index: 10;
    cursor: pointer;
    user-select: none;
    will-change: transform;
}

.gantt-bar-obra span {
    font-size: 8.5px !important;
    font-weight: 400 !important;
    padding: 0 6px;
    display: block;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
}

.gantt-resize-handle {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 6px;
    z-index: 25;
    cursor: col-resize;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.2s;
}

@media (hover: hover) {
    .gantt-bar-obra:hover .gantt-resize-handle {
        opacity: 1;
    }
}

/* Touch devices: always visible, larger touch target */
@media (hover: none) {
    .gantt-resize-handle {
        opacity: 1;
        width: 16px;
    }
}

.gantt-resize-handle.left {
    left: 0px;
}

.gantt-resize-handle.right {
    right: 0px;
}

.gantt-resize-handle::after {
    content: '';
    width: 2px;
    height: 10px;
    background: rgba(255, 255, 255, 0.7);
    border-radius: 1px;
}

@media (hover: hover) {
    .gantt-resize-handle:hover::after {
        background: white;
        width: 3px;
        height: 14px;
    }
}

@media (hover: none) {
    .gantt-resize-handle::after {
        background: white;
        width: 3px;
        height: 14px;
    }
}

.gantt-bar-trab {
    position: absolute;
    height: 18px;
    background: #edf2f7;
    color: #4a5568;
    border-radius: 3px;
    font-size: 9px;
    display: flex;
    align-items: center;
    padding: 0 8px;
    white-space: nowrap;
    border: 1px solid #cbd5e0;
}

.planeamento-header .view-controls {
    display: flex;
    gap: 15px;
    align-items: center;
}

.gantt-filters {
    display: flex;
    background: #edf2f7;
    padding: 4px;
    border-radius: 8px;
    gap: 2px;
}

.filter-btn {
    padding: 6px 12px;
    border: none;
    background: transparent;
    color: #4a5568;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    border-radius: 6px;
    transition: all 0.2s;
}

.filter-btn:hover {
    background: #e2e8f0;
}

.filter-btn.active {
    background: white;
    color: #3182ce;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.gantt-bar-obra {
    cursor: pointer;
}

@media (hover: hover) {
    .gantt-bar-obra:hover {
        transform: scaleY(1.1);
        z-index: 10;
    }
}

/* Modal Styles */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1100;
}

.planeamento-modal-content {
    background: white;
    padding: 30px;
    border-radius: 12px;
    width: 100%;
    max-width: 500px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.modal-header h2 {
    margin: 0;
    font-size: 20px;
    color: #2d3748;
}

.btn-close {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #a0aec0;
}

.form-group {
    margin-bottom: 15px;
}

.form-group label {
    display: block;
    margin-bottom: 5px;
    font-size: 14px;
    font-weight: 600;
    color: #4a5568;
}

.form-group input,
.form-group select {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 14px;
}

.form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
}

.modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 25px;
}

.btn-primary {
    background: #3182ce;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 6px;
    font-weight: 600;
    cursor: pointer;
    user-select: none;
}

.btn-secondary {
    background: #edf2f7;
    color: #4a5568;
    border: none;
    padding: 10px 20px;
    border-radius: 6px;
    font-weight: 600;
    cursor: pointer;
    user-select: none;
}

.btn-primary:hover {
    background: #2b6cb0;
}

.btn-secondary:hover {
    background: #e2e8f0;
}

.color-palette {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 5px;
}

.color-swatch {
    width: 32px;
    height: 32px;
    border-radius: 6px;
    border: 2px solid transparent;
    cursor: pointer;
    transition: all 0.2s;
}

.color-swatch:hover {
    transform: scale(1.1);
}

.color-swatch.active {
    border-color: #2d3748;
    box-shadow: 0 0 0 2px white inset;
}

/* Pending Alerts Floating Panel */
.pending-alerts-floating-panel {
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 320px;
    background: white;
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
    border: 1px solid #e2e8f0;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.pending-alerts-floating-panel header {
    padding: 12px 15px;
    background: #fdf2f2;
    border-bottom: 1px solid #fee2e2;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    font-weight: 700;
    color: #c53030;
    font-size: 14px;
}

.alerts-bulk-actions {
    display: flex;
    gap: 6px;
    margin-left: auto;
}

.alerts-bulk-actions button {
    padding: 4px 10px;
    font-size: 12px;
    font-weight: 600;
    border-radius: 4px;
    border: none;
    cursor: pointer;
}

.alerts-bulk-actions .btn-send {
    background: #10b981;
    color: white;
}

.alerts-bulk-actions .btn-send:hover {
    background: #059669;
}

.alerts-bulk-actions .btn-dismiss {
    background: #e5e7eb;
    color: #374151;
}

.alerts-bulk-actions .btn-dismiss:hover {
    background: #d1d5db;
}

.alerts-list {
    max-height: 250px;
    overflow-y: auto;
    padding: 5px;
}

.alert-item {
    padding: 10px;
    border-bottom: 1px solid #f7fafc;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
}

.alert-info {
    display: flex;
    flex-direction: column;
    font-size: 12px;
}

.alert-info strong {
    color: #2d3748;
}

.alert-info span {
    color: #718096;
}

.alert-actions {
    display: flex;
    gap: 5px;
}

.btn-send {
    background: #38a169;
    color: white;
    border: none;
    padding: 4px 10px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 700;
    cursor: pointer;
}

.btn-dismiss {
    background: #edf2f7;
    color: #718096;
    border: none;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
}

.btn-send:hover {
    background: #2f855a;
}

.btn-dismiss:hover {
    background: #e2e8f0;
}

.btn-customize {
    background: #ebf8ff;
    color: #2b6cb0;
    border: 1px solid #bee3f8;
    padding: 4px 7px;
    border-radius: 4px;
    font-size: 12px;
    cursor: pointer;
    line-height: 1;
}
.btn-customize:hover {
    background: #bee3f8;
}

/* Gantt Today Marker */
.gantt-today-marker {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 2px;
    background-color: #e53e3e;
    z-index: 50;
    pointer-events: none;
    box-shadow: 0 0 4px rgba(229, 62, 62, 0.4);
}

.gantt-today-badge {
    position: absolute;
    top: -24px;
    left: 50%;
    transform: translateX(-50%);
    background: #e53e3e;
    color: white;
    font-size: 10px;
    font-weight: bold;
    padding: 2px 6px;
    border-radius: 4px;
    white-space: nowrap;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.gantt-today-badge::after {
    content: '';
    position: absolute;
    bottom: -4px;
    left: 50%;
    transform: translateX(-50%);
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 4px solid #e53e3e;
}

/* Modal uniforme (estilo nota encomenda) */
.modal-ef { background: white; border-radius: 16px; padding: 28px; max-width: 500px; width: 95%; box-shadow: 0 20px 25px rgba(0,0,0,0.15); }
.modal-ef-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; padding-bottom: 14px; border-bottom: 1px solid #e2e8f0; }
.modal-ef-num { font-weight: 700; font-size: 16px; color: #1e293b; }
.modal-close { background: none; border: none; font-size: 28px; line-height: 1; cursor: pointer; color: #64748b; padding: 4px; width: 36px; height: 36px; display: flex; align-items: center; justify-content: center; border-radius: 8px; transition: all 0.15s; }
.modal-close:hover { color: #1e293b; background: #f1f5f9; }
.modal-form-body { padding: 4px 0 0; }
.modal-form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 16px; }
.modal-field { display: flex; flex-direction: column; gap: 4px; }
.modal-field.full { grid-column: 1 / -1; }
.modal-field label { font-size: 10px; font-weight: 700; color: #888; text-transform: uppercase; letter-spacing: 0.4px; }
.modal-field input, .modal-field textarea, .modal-field select { padding: 9px 12px; border: 1px solid #e2e8f0; border-radius: 8px; font-family: inherit; font-size: 13px; transition: border-color 0.15s; }
.modal-field input:focus, .modal-field textarea:focus, .modal-field select:focus { outline: none; border-color: #5b4fcf; box-shadow: 0 0 0 3px rgba(91,79,207,0.08); }
.modal-form-actions { display: flex; justify-content: flex-end; gap: 8px; padding-top: 16px; border-top: 1px solid #e2e8f0; margin-top: 8px; }
.btn-modal-cancel { padding: 10px 20px; background: #f3f4f6; border: 1px solid #dde1e7; border-radius: 8px; cursor: pointer; font-size: 13px; font-weight: 600; min-height: 38px; display: inline-flex; align-items: center; gap: 6px; transition: all 0.15s; }
.btn-modal-cancel:hover { background: #e5e7eb; }
.btn-modal-save { padding: 10px 20px; background: #3182ce; color: white; border: none; border-radius: 8px; cursor: pointer; font-size: 13px; font-weight: 600; min-height: 38px; display: inline-flex; align-items: center; gap: 6px; transition: all 0.15s; }
.btn-modal-save:hover:not(:disabled) { background: #2b6cb0; }
.btn-modal-save:disabled { opacity: 0.6; cursor: not-allowed; }
/* Splitter arrastável entre Gantt e painel de trabalhadores */
.trab-panel-splitter {
    height: 10px;
    margin: 4px 0 -2px 0;
    cursor: row-resize;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
}
.trab-panel-splitter-handle {
    width: 60px;
    height: 4px;
    background: #cbd5e0;
    border-radius: 2px;
    transition: background 0.15s;
}
.trab-panel-splitter:hover .trab-panel-splitter-handle { background: #3182ce; }
.trab-panel-splitter:active .trab-panel-splitter-handle { background: #2b6cb0; }

/* Painel de Trabalhadores (drag & drop para o Gantt) */
.trab-panel {
    margin-top: 10px;
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    padding: 8px 12px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.04);
    display: flex;
    flex-direction: column;
    min-height: 120px;
    overflow: hidden;
}
.trab-panel-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 6px;
    padding-bottom: 6px;
    border-bottom: 1px solid #edf2f7;
    flex-wrap: wrap;
}
.trab-panel-header strong { color: #2d3748; font-size: 13px; }
.trab-panel-hint { color: #94a3b8; font-size: 11px; font-style: italic; margin-left: auto; }
.trab-week-selector {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background: #f1f5f9;
    border-radius: 6px;
    padding: 2px 4px;
}
.trab-week-selector button {
    background: white;
    border: 1px solid #cbd5e0;
    border-radius: 4px;
    padding: 2px 8px;
    font-size: 11px;
    cursor: pointer;
    color: #2d3748;
    transition: all 0.15s;
}
.trab-week-selector button:hover { background: #ebf8ff; border-color: #3182ce; }
.trab-week-label { font-size: 12px; font-weight: 600; color: #2d3748; padding: 0 6px; min-width: 130px; text-align: center; }
.trab-week-today { background: #3182ce !important; color: white !important; border-color: #3182ce !important; font-weight: 600; }
.trab-week-today:hover { background: #2b6cb0 !important; }

.trab-panel-grupos {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    flex: 1 1;
    min-height: 0;
    overflow: hidden;
}
.trab-panel-grupo {
    background: #fafbfc;
    border: 1px solid #edf2f7;
    border-radius: 6px;
    padding: 6px 8px;
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
}
.trab-grupo-label {
    display: inline-block;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    margin-bottom: 4px;
}
.trab-grupo-label.livre { color: #38a169; }
.trab-grupo-label.atribuido { color: #3182ce; }
.trab-empty { color: #cbd5e0; font-size: 11px; }

.trab-panel-list {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    gap: 4px;
    flex: 1 1;
    min-height: 0;
    overflow-y: auto;
}
.trab-chip {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 2px 8px 2px 2px;
    background: #f8fafc;
    border: 1px solid #cbd5e0;
    border-radius: 14px;
    cursor: grab;
    user-select: none;
    transition: all 0.15s;
    font-size: 11px;
    line-height: 1;
}
.trab-chip:hover { background: #ebf8ff; border-color: #3182ce; transform: translateY(-1px); }
.trab-chip:active, .trab-chip.dragging { cursor: grabbing; opacity: 0.5; transform: scale(0.95); }
.trab-chip.atribuido { background: #ebf8ff; border-color: #90cdf4; }
.trab-chip.atribuido .trab-chip-iniciais { background: #2c5282; }
.trab-chip.livre .trab-chip-iniciais { background: #38a169; }
.trab-chip-iniciais {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 22px;
    height: 18px;
    padding: 0 5px;
    background: #3182ce;
    color: white;
    border-radius: 10px;
    font-weight: 700;
    font-size: 9px;
}
.trab-chip-nome { color: #2d3748; font-weight: 500; font-size: 11px; }
/* Alocado a uma obra fora do filtro atual (ex.: concluída) — não aparece no Gantt visível */
.trab-chip.fora-vista { background: #fffbeb; border-color: #f59e0b; }
.trab-chip.fora-vista .trab-chip-iniciais { background: #b45309; }
.trab-chip-flag { color: #b45309; font-size: 11px; margin-left: 1px; cursor: help; }

/* Iniciais dentro da barra do Gantt — agrupadas por semana, posicionadas no offset correcto */
.gantt-bar-iniciais-grupo {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    display: inline-flex;
    gap: 2px;
    align-items: center;
    z-index: 5;
    width: auto;
    white-space: nowrap;
    /* Confina os crachás à largura da própria semana para não invadirem a seguinte */
    overflow: hidden;
}
/* Indicador "+N" para os trabalhadores que não cabem na largura da semana */
.trab-inicial-mais {
    background: rgba(0, 0, 0, 0.55) !important;
    color: #fff !important;
    border-color: rgba(0, 0, 0, 0.2) !important;
    cursor: default;
    flex-shrink: 0;
}
.trab-inicial-mais:hover {
    background: rgba(0, 0, 0, 0.7) !important;
    color: #fff !important;
    transform: none;
}
.trab-inicial-chip {
    padding: 0 5px;
    height: 16px;
    line-height: 16px;
    font-size: 9px;
    font-weight: 700;
    border-radius: 8px;
}
.trab-inicial-chip {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 1px 6px;
    background: rgba(255,255,255,0.95);
    color: #1a202c;
    border-radius: 10px;
    font-size: 10px;
    font-weight: 700;
    cursor: pointer;
    border: 1px solid rgba(0,0,0,0.1);
    white-space: nowrap;
    transition: all 0.15s;
}
.trab-inicial-chip:hover { background: #fed7d7; color: #c53030; transform: scale(1.05); }

/* Highlight da barra quando se arrasta um trabalhador por cima */
.gantt-bar-obra.drag-over { outline: 2px dashed #38a169; outline-offset: -2px; }

/* Pesquisa e localização: os resultados são as próprias linhas do calendário. */
.planeamento-container .planeamento-search { flex: 1 1 380px; max-width: 560px; min-width: 0; }
.planeamento-search > label { display: block; margin-bottom: 5px; font-size: 12px; font-weight: 600; }
.planeamento-container .planeamento-search-controls { display: flex; align-items: center; gap: 6px; margin-bottom: 0; }
.planeamento-container .planeamento-search-controls input { flex: 1 1; min-width: 0; width: 100%; padding: 8px 10px; font: inherit; }
.planeamento-search-controls button { flex-shrink: 0; white-space: nowrap; cursor: pointer; }
.planeamento-search-controls button:disabled { opacity: .55; cursor: not-allowed; }
.planeamento-search-status { display: block; min-height: 30px; margin-top: 4px; font-size: 11px; line-height: 15px; }
.planeamento-container .gantt-obra-location { width: 100%; border-top: 0; border-left: 0; border-right: 0; border-radius: 0; background: transparent; color: inherit; font-family: inherit; text-align: left; cursor: pointer; }
.planeamento-container .gantt-obra-location:hover { background-color: #d9eaff88; }
.planeamento-container .gantt-obra-location:focus-visible { outline: 2px solid #367ab9; outline-offset: -3px; }
.planeamento-container .gantt-row-label.obra-localizada,
.planeamento-container .gantt-row-content.obra-localizada { background-color: #3182ce20; box-shadow: inset 3px 0 #3182ce; }
.planeamento-search input:focus-visible { outline: 2px solid #367ab9; outline-offset: 2px; }
@media (max-width: 600px) {
    .planeamento-container .planeamento-search { flex-basis: 100%; max-width: none; }
    .planeamento-container .planeamento-search-controls { flex-wrap: wrap; }
    .planeamento-container .planeamento-search-controls input { flex-basis: 100%; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Planeamento.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,+BAA+B;IAC/B,iBAAiB;IACjB,mBAAmB;IACnB,yCAAyC;IACzC,yBAAyB;IACzB,2BAA2B;IAC3B,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,+BAA+B;IAC/B,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,wBAAwB;IACxB,YAAY;IACZ,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA,sCAAsC;AACtC;;IAEI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,+CAA+C;IAC/C,YAAY;IACZ,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gCAAgC;IAChC,mBAAmB;IACnB,+BAA+B;IAC/B,+BAA+B;IAC/B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,6CAA6C;IAC7C,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,+BAA+B;IAC/B,0BAA0B;IAC1B,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,mBAAmB;AACvB;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,oBAAoB;IACpB,UAAU;AACd;;AAEA,uEAAuE;AACvE;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,oCAAoC;IACpC,8BAA8B;IAC9B,+BAA+B;IAC/B,oBAAoB;IACpB,UAAU;AACd;AACA;IACI,0CAA0C;IAC1C,cAAc;IACd,gBAAgB;AACpB;AACA,sCAAsC,yBAAyB,EAAE,cAAc,EAAE;;AAEjF;IACI,YAAY;IACZ,qCAAqC;IACrC,cAAc;IACd,kBAAkB;IAClB,gCAAgC;IAChC,sBAAsB;IACtB,iBAAiB;IACjB;;;;;;KAMC;IACD,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,+BAA+B;IAC/B,cAAc;IACd,kBAAkB;IAClB,2BAA2B;IAC3B,WAAW;IACX,4BAA4B;IAC5B,oBAAoB;IACpB,kDAAkD;IAClD,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,0CAA0C;IAC1C,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;IACrB,SAAS;IACT,4BAA4B;IAC5B,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,cAAc;IACd,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA,uDAAuD;AACvD;IACI;QACI,UAAU;QACV,WAAW;IACf;AACJ;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,UAAU;IACV,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI;QACI,iBAAiB;QACjB,UAAU;QACV,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,UAAU;QACV,YAAY;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,sBAAsB;QACtB,WAAW;IACf;AACJ;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,iCAAiC;AACrC;;AAEA,kCAAkC;AAClC;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,2CAA2C;IAC3C,yBAAyB;IACzB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,cAAc;AAClB;AACA;IACI,mBAAmB;AACvB;;AAEA,uBAAuB;AACvB;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,UAAU;IACV,yBAAyB;IACzB,WAAW;IACX,oBAAoB;IACpB,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,2BAA2B;IAC3B,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,kCAAkC;IAClC,mCAAmC;IACnC,6BAA6B;AACjC;;AAEA,2CAA2C;AAC3C,YAAY,iBAAiB,EAAE,mBAAmB,EAAE,aAAa,EAAE,gBAAgB,EAAE,UAAU,EAAE,wCAAwC,EAAE;AAC3I,mBAAmB,aAAa,EAAE,8BAA8B,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,oBAAoB,EAAE,gCAAgC,EAAE;AACpK,gBAAgB,gBAAgB,EAAE,eAAe,EAAE,cAAc,EAAE;AACnE,eAAe,gBAAgB,EAAE,YAAY,EAAE,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE,cAAc,EAAE,YAAY,EAAE,WAAW,EAAE,YAAY,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,kBAAkB,EAAE,qBAAqB,EAAE;AAClQ,qBAAqB,cAAc,EAAE,mBAAmB,EAAE;AAC1D,mBAAmB,gBAAgB,EAAE;AACrC,mBAAmB,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE,mBAAmB,EAAE;AAClG,eAAe,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAChE,oBAAoB,mBAAmB,EAAE;AACzC,qBAAqB,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE,yBAAyB,EAAE,qBAAqB,EAAE;AACvH,iEAAiE,iBAAiB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,oBAAoB,EAAE,eAAe,EAAE,8BAA8B,EAAE;AAC1M,mFAAmF,aAAa,EAAE,qBAAqB,EAAE,0CAA0C,EAAE;AACrK,sBAAsB,aAAa,EAAE,yBAAyB,EAAE,QAAQ,EAAE,iBAAiB,EAAE,6BAA6B,EAAE,eAAe,EAAE;AAC7I,oBAAoB,kBAAkB,EAAE,mBAAmB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,qBAAqB,EAAE;AAC9P,0BAA0B,mBAAmB,EAAE;AAC/C,kBAAkB,kBAAkB,EAAE,mBAAmB,EAAE,YAAY,EAAE,YAAY,EAAE,kBAAkB,EAAE,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,qBAAqB,EAAE;AAC7P,uCAAuC,mBAAmB,EAAE;AAC5D,2BAA2B,YAAY,EAAE,mBAAmB,EAAE;AAC9D,8DAA8D;AAC9D;IACI,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,4BAA4B;AAChC;AACA,yDAAyD,mBAAmB,EAAE;AAC9E,0DAA0D,mBAAmB,EAAE;;AAE/E,uDAAuD;AACvD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,sCAAsC;IACtC,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;AACnB;AACA,4BAA4B,cAAc,EAAE,eAAe,EAAE;AAC7D,mBAAmB,cAAc,EAAE,eAAe,EAAE,kBAAkB,EAAE,iBAAiB,EAAE;AAC3F;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,cAAc;IACd,qBAAqB;AACzB;AACA,mCAAmC,mBAAmB,EAAE,qBAAqB,EAAE;AAC/E,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,cAAc,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AAC5H,mBAAmB,8BAA8B,EAAE,uBAAuB,EAAE,gCAAgC,EAAE,gBAAgB,EAAE;AAChI,yBAAyB,8BAA8B,EAAE;;AAEzD;IACI,aAAa;IACb,8BAA8B;IAC9B,QAAQ;IACR,SAAO;IACP,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;AACtB;AACA,0BAA0B,cAAc,EAAE;AAC1C,8BAA8B,cAAc,EAAE;AAC9C,cAAc,cAAc,EAAE,eAAe,EAAE;;AAE/C;IACI,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,QAAQ;IACR,SAAO;IACP,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,wBAAwB;IACxB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;IACrB,eAAe;IACf,cAAc;AAClB;AACA,mBAAmB,mBAAmB,EAAE,qBAAqB,EAAE,2BAA2B,EAAE;AAC5F,yCAAyC,gBAAgB,EAAE,YAAY,EAAE,sBAAsB,EAAE;AACjG,uBAAuB,mBAAmB,EAAE,qBAAqB,EAAE;AACnE,2CAA2C,mBAAmB,EAAE;AAChE,uCAAuC,mBAAmB,EAAE;AAC5D;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;AACA,kBAAkB,cAAc,EAAE,gBAAgB,EAAE,eAAe,EAAE;AACrE,4FAA4F;AAC5F,wBAAwB,mBAAmB,EAAE,qBAAqB,EAAE;AACpE,4CAA4C,mBAAmB,EAAE;AACjE,kBAAkB,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,YAAY,EAAE;;AAEnF,8FAA8F;AAC9F;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,oBAAoB;IACpB,QAAQ;IACR,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,iFAAiF;IACjF,gBAAgB;AACpB;AACA,4EAA4E;AAC5E;IACI,0CAA0C;IAC1C,sBAAsB;IACtB,2CAA2C;IAC3C,eAAe;IACf,cAAc;AAClB;AACA;IACI,yCAAyC;IACzC,sBAAsB;IACtB,eAAe;AACnB;AACA;IACI,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,kCAAkC;IAClC,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iCAAiC;IACjC,mBAAmB;IACnB,qBAAqB;AACzB;AACA,2BAA2B,mBAAmB,EAAE,cAAc,EAAE,sBAAsB,EAAE;;AAExF,iEAAiE;AACjE,4BAA4B,2BAA2B,EAAE,oBAAoB,EAAE;;AAE/E,gFAAgF;AAChF,6CAA6C,eAAe,EAAE,gBAAgB,EAAE,YAAY,EAAE;AAC9F,8BAA8B,cAAc,EAAE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACrG,sDAAsD,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,gBAAgB,EAAE;AACtH,4DAA4D,SAAO,EAAE,YAAY,EAAE,WAAW,EAAE,iBAAiB,EAAE,aAAa,EAAE;AAClI,sCAAsC,cAAc,EAAE,mBAAmB,EAAE,eAAe,EAAE;AAC5F,+CAA+C,YAAY,EAAE,mBAAmB,EAAE;AAClF,6BAA6B,cAAc,EAAE,gBAAgB,EAAE,eAAe,EAAE,eAAe,EAAE,iBAAiB,EAAE;AACpH,8CAA8C,WAAW,EAAE,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,cAAc,EAAE,oBAAoB,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAC/N,oDAAoD,2BAA2B,EAAE;AACjF,4DAA4D,0BAA0B,EAAE,oBAAoB,EAAE;AAC9G;4DAC4D,2BAA2B,EAAE,+BAA+B,EAAE;AAC1H,0CAA0C,0BAA0B,EAAE,mBAAmB,EAAE;AAC3F;IACI,6CAA6C,gBAAgB,EAAE,eAAe,EAAE;IAChF,sDAAsD,eAAe,EAAE;IACvE,4DAA4D,gBAAgB,EAAE;AAClF","sourcesContent":[".planeamento-page {\r\n    display: flex;\r\n    flex-direction: column;\r\n    min-height: 100%;\r\n}\r\n\r\n.planeamento-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    min-height: 100%;\r\n}\r\n\r\n.planeamento-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 30px;\r\n}\r\n\r\n.planeamento-header h1 {\r\n    font-size: 24px;\r\n    color: #2d3748;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.planeamento-header p {\r\n    color: #718096;\r\n}\r\n\r\n.gantt-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    /* Headers on top, body below */\r\n    background: white;\r\n    border-radius: 12px;\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\r\n    border: 1px solid #e2e8f0;\r\n    height: calc(100vh - 480px);\r\n    min-height: 280px;\r\n    overflow: hidden;\r\n}\r\n\r\n.gantt-sidebar-column {\r\n    width: 250px;\r\n    flex-shrink: 0;\r\n    border-right: 2px solid #edf2f7;\r\n    background: #f8fafc;\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n    scrollbar-width: none;\r\n    /* Firefox */\r\n    -ms-overflow-style: none;\r\n    /* IE/Edge */\r\n    -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n.gantt-sidebar-column::-webkit-scrollbar {\r\n    display: none;\r\n    /* Chrome/Safari */\r\n}\r\n\r\n/* Obsolete classes override/cleanup */\r\n.gantt-main,\r\n.gantt-sidebar {\r\n    display: none;\r\n}\r\n\r\n.gantt-sidebar-header {\r\n    width: 250px;\r\n    /* IMPORTANT: Match sidebar text column width */\r\n    height: 80px;\r\n    flex-shrink: 0;\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 0 20px;\r\n    font-weight: 700;\r\n    color: #4a5568;\r\n    border-bottom: 2px solid #edf2f7;\r\n    background: #f8fafc;\r\n    border-right: 2px solid #edf2f7;\r\n    /* Add border to match column */\r\n    box-sizing: border-box;\r\n}\r\n\r\n.gantt-row-label {\r\n    height: 38px;\r\n    /* Force fixed height to match content rows */\r\n    flex-shrink: 0;\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 0 10px;\r\n    border-bottom: 1px solid #edf2f7;\r\n    box-sizing: border-box;\r\n    overflow: hidden;\r\n    font-size: 13px;\r\n}\r\n\r\n.obra-info {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.obra-info strong {\r\n    font-size: 11px;\r\n    margin-bottom: 2px;\r\n}\r\n\r\n.obra-info small {\r\n    font-size: 9px;\r\n}\r\n\r\n.obra-dot {\r\n    width: 12px;\r\n    height: 12px;\r\n    border-radius: 50%;\r\n    display: inline-block;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.gantt-timeline-wrapper {\r\n    flex-grow: 1;\r\n    overflow-x: auto;\r\n    position: relative;\r\n    background: white;\r\n    -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n.gantt-timeline-header {\r\n    display: flex;\r\n    height: 40px;\r\n    border-bottom: 1px solid #edf2f7;\r\n    background: #ebf4ff;\r\n}\r\n\r\n.gantt-timeline-month {\r\n    flex-shrink: 0;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 13px;\r\n    font-weight: 700;\r\n    color: #2c5282;\r\n    border-right: 3px solid #2b6cb0;\r\n    text-transform: capitalize;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.gantt-timeline-month:nth-child(even) {\r\n    background: #dbeafe;\r\n}\r\n\r\n.gantt-timeline-month:nth-child(odd) {\r\n    background: #eff6ff;\r\n}\r\n\r\n.gantt-timeline-days {\r\n    display: flex;\r\n    height: 40px;\r\n    border-bottom: 2px solid #edf2f7;\r\n}\r\n\r\n.gantt-day-cell {\r\n    width: 40px;\r\n    min-width: 40px;\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 12px;\r\n    color: #718096;\r\n    border-right: 1px solid #cbd5e0;\r\n}\r\n\r\n.gantt-day-cell.weekend {\r\n    background-color: #f7fafc;\r\n}\r\n\r\n.gantt-day-cell.today {\r\n    background-color: #fff5f5;\r\n    color: #e53e3e;\r\n    position: relative;\r\n}\r\n\r\n.gantt-day-cell.today::after {\r\n    content: '';\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    height: 3px;\r\n    background: #e53e3e;\r\n}\r\n\r\n.gantt-day-cell.month-end,\r\n.gantt-cell.month-end {\r\n    border-right: 2px solid #2b6cb0;\r\n}\r\n\r\n.gantt-day-cell.week-start {\r\n    border-left: 2px solid #94a3b8;\r\n}\r\n\r\n.gantt-week-line {\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    width: 2px;\r\n    background: #94a3b8;\r\n    pointer-events: none;\r\n    z-index: 1;\r\n}\r\n\r\n/* Semana seleccionada no painel: faixa no corpo + destaque no header */\r\n.gantt-selected-week {\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    background: rgba(49, 130, 206, 0.07);\r\n    border-left: 2px solid #3182ce;\r\n    border-right: 2px solid #3182ce;\r\n    pointer-events: none;\r\n    z-index: 2;\r\n}\r\n.gantt-day-cell.selected-week {\r\n    background-color: rgba(49, 130, 206, 0.12);\r\n    color: #2b6cb0;\r\n    font-weight: 700;\r\n}\r\n.gantt-day-cell.selected-week.today { background-color: #fed7d7; color: #c53030; }\r\n\r\n.gantt-row-content {\r\n    height: 38px;\r\n    /* Force fixed height for alignment */\r\n    flex-shrink: 0;\r\n    position: relative;\r\n    border-bottom: 1px solid #edf2f7;\r\n    box-sizing: border-box;\r\n    user-select: none;\r\n    background-image: repeating-linear-gradient(\r\n        to right,\r\n        transparent 0px,\r\n        transparent 39px,\r\n        #cbd5e0 39px,\r\n        #cbd5e0 40px\r\n    );\r\n    background-size: 40px 100%;\r\n}\r\n\r\n.gantt-cell {\r\n    width: 40px;\r\n    min-width: 40px;\r\n    height: 100%;\r\n    border-right: 1px solid #cbd5e0;\r\n    flex-shrink: 0;\r\n    position: relative;\r\n    /* Para z-index funcionar */\r\n    z-index: 20;\r\n    /* Ficar por cima da barra */\r\n    pointer-events: none;\r\n    /* Deixar cliques passarem para a barra em baixo */\r\n    background: transparent;\r\n    user-select: none;\r\n    cursor: default;\r\n}\r\n\r\n.gantt-cell.weekend {\r\n    background-color: rgba(247, 250, 252, 0.6);\r\n    /* Transparente para ver a barra por baixo */\r\n}\r\n\r\n.gantt-bar-obra {\r\n    position: absolute;\r\n    height: 18px;\r\n    /* Slightly thinner */\r\n    top: 10px;\r\n    /* Repositioned for center */\r\n    border-radius: 4px;\r\n    color: white;\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 0;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    z-index: 10;\r\n    cursor: pointer;\r\n    user-select: none;\r\n    will-change: transform;\r\n}\r\n\r\n.gantt-bar-obra span {\r\n    font-size: 8.5px !important;\r\n    font-weight: 400 !important;\r\n    padding: 0 6px;\r\n    display: block;\r\n    width: 100%;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.gantt-resize-handle {\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    width: 6px;\r\n    z-index: 25;\r\n    cursor: col-resize;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    opacity: 0;\r\n    transition: opacity 0.2s;\r\n}\r\n\r\n@media (hover: hover) {\r\n    .gantt-bar-obra:hover .gantt-resize-handle {\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n/* Touch devices: always visible, larger touch target */\r\n@media (hover: none) {\r\n    .gantt-resize-handle {\r\n        opacity: 1;\r\n        width: 16px;\r\n    }\r\n}\r\n\r\n.gantt-resize-handle.left {\r\n    left: 0px;\r\n}\r\n\r\n.gantt-resize-handle.right {\r\n    right: 0px;\r\n}\r\n\r\n.gantt-resize-handle::after {\r\n    content: '';\r\n    width: 2px;\r\n    height: 10px;\r\n    background: rgba(255, 255, 255, 0.7);\r\n    border-radius: 1px;\r\n}\r\n\r\n@media (hover: hover) {\r\n    .gantt-resize-handle:hover::after {\r\n        background: white;\r\n        width: 3px;\r\n        height: 14px;\r\n    }\r\n}\r\n\r\n@media (hover: none) {\r\n    .gantt-resize-handle::after {\r\n        background: white;\r\n        width: 3px;\r\n        height: 14px;\r\n    }\r\n}\r\n\r\n.gantt-bar-trab {\r\n    position: absolute;\r\n    height: 18px;\r\n    background: #edf2f7;\r\n    color: #4a5568;\r\n    border-radius: 3px;\r\n    font-size: 9px;\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 0 8px;\r\n    white-space: nowrap;\r\n    border: 1px solid #cbd5e0;\r\n}\r\n\r\n.planeamento-header .view-controls {\r\n    display: flex;\r\n    gap: 15px;\r\n    align-items: center;\r\n}\r\n\r\n.gantt-filters {\r\n    display: flex;\r\n    background: #edf2f7;\r\n    padding: 4px;\r\n    border-radius: 8px;\r\n    gap: 2px;\r\n}\r\n\r\n.filter-btn {\r\n    padding: 6px 12px;\r\n    border: none;\r\n    background: transparent;\r\n    color: #4a5568;\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    border-radius: 6px;\r\n    transition: all 0.2s;\r\n}\r\n\r\n.filter-btn:hover {\r\n    background: #e2e8f0;\r\n}\r\n\r\n.filter-btn.active {\r\n    background: white;\r\n    color: #3182ce;\r\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.gantt-bar-obra {\r\n    cursor: pointer;\r\n}\r\n\r\n@media (hover: hover) {\r\n    .gantt-bar-obra:hover {\r\n        transform: scaleY(1.1);\r\n        z-index: 10;\r\n    }\r\n}\r\n\r\n/* Modal Styles */\r\n.modal-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 1100;\r\n}\r\n\r\n.planeamento-modal-content {\r\n    background: white;\r\n    padding: 30px;\r\n    border-radius: 12px;\r\n    width: 100%;\r\n    max-width: 500px;\r\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.modal-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.modal-header h2 {\r\n    margin: 0;\r\n    font-size: 20px;\r\n    color: #2d3748;\r\n}\r\n\r\n.btn-close {\r\n    background: none;\r\n    border: none;\r\n    font-size: 24px;\r\n    cursor: pointer;\r\n    color: #a0aec0;\r\n}\r\n\r\n.form-group {\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.form-group label {\r\n    display: block;\r\n    margin-bottom: 5px;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    color: #4a5568;\r\n}\r\n\r\n.form-group input,\r\n.form-group select {\r\n    width: 100%;\r\n    padding: 8px 12px;\r\n    border: 1px solid #e2e8f0;\r\n    border-radius: 6px;\r\n    font-size: 14px;\r\n}\r\n\r\n.form-grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 15px;\r\n}\r\n\r\n.modal-actions {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    gap: 10px;\r\n    margin-top: 25px;\r\n}\r\n\r\n.btn-primary {\r\n    background: #3182ce;\r\n    color: white;\r\n    border: none;\r\n    padding: 10px 20px;\r\n    border-radius: 6px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    user-select: none;\r\n}\r\n\r\n.btn-secondary {\r\n    background: #edf2f7;\r\n    color: #4a5568;\r\n    border: none;\r\n    padding: 10px 20px;\r\n    border-radius: 6px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    user-select: none;\r\n}\r\n\r\n.btn-primary:hover {\r\n    background: #2b6cb0;\r\n}\r\n\r\n.btn-secondary:hover {\r\n    background: #e2e8f0;\r\n}\r\n\r\n.color-palette {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: 8px;\r\n    margin-top: 5px;\r\n}\r\n\r\n.color-swatch {\r\n    width: 32px;\r\n    height: 32px;\r\n    border-radius: 6px;\r\n    border: 2px solid transparent;\r\n    cursor: pointer;\r\n    transition: all 0.2s;\r\n}\r\n\r\n.color-swatch:hover {\r\n    transform: scale(1.1);\r\n}\r\n\r\n.color-swatch.active {\r\n    border-color: #2d3748;\r\n    box-shadow: 0 0 0 2px white inset;\r\n}\r\n\r\n/* Pending Alerts Floating Panel */\r\n.pending-alerts-floating-panel {\r\n    position: fixed;\r\n    bottom: 20px;\r\n    right: 20px;\r\n    width: 320px;\r\n    background: white;\r\n    border-radius: 12px;\r\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);\r\n    border: 1px solid #e2e8f0;\r\n    z-index: 1000;\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow: hidden;\r\n}\r\n\r\n.pending-alerts-floating-panel header {\r\n    padding: 12px 15px;\r\n    background: #fdf2f2;\r\n    border-bottom: 1px solid #fee2e2;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    gap: 8px;\r\n    font-weight: 700;\r\n    color: #c53030;\r\n    font-size: 14px;\r\n}\r\n\r\n.alerts-bulk-actions {\r\n    display: flex;\r\n    gap: 6px;\r\n    margin-left: auto;\r\n}\r\n\r\n.alerts-bulk-actions button {\r\n    padding: 4px 10px;\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n    border-radius: 4px;\r\n    border: none;\r\n    cursor: pointer;\r\n}\r\n\r\n.alerts-bulk-actions .btn-send {\r\n    background: #10b981;\r\n    color: white;\r\n}\r\n\r\n.alerts-bulk-actions .btn-send:hover {\r\n    background: #059669;\r\n}\r\n\r\n.alerts-bulk-actions .btn-dismiss {\r\n    background: #e5e7eb;\r\n    color: #374151;\r\n}\r\n\r\n.alerts-bulk-actions .btn-dismiss:hover {\r\n    background: #d1d5db;\r\n}\r\n\r\n.alerts-list {\r\n    max-height: 250px;\r\n    overflow-y: auto;\r\n    padding: 5px;\r\n}\r\n\r\n.alert-item {\r\n    padding: 10px;\r\n    border-bottom: 1px solid #f7fafc;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    gap: 10px;\r\n}\r\n\r\n.alert-info {\r\n    display: flex;\r\n    flex-direction: column;\r\n    font-size: 12px;\r\n}\r\n\r\n.alert-info strong {\r\n    color: #2d3748;\r\n}\r\n\r\n.alert-info span {\r\n    color: #718096;\r\n}\r\n\r\n.alert-actions {\r\n    display: flex;\r\n    gap: 5px;\r\n}\r\n\r\n.btn-send {\r\n    background: #38a169;\r\n    color: white;\r\n    border: none;\r\n    padding: 4px 10px;\r\n    border-radius: 4px;\r\n    font-size: 11px;\r\n    font-weight: 700;\r\n    cursor: pointer;\r\n}\r\n\r\n.btn-dismiss {\r\n    background: #edf2f7;\r\n    color: #718096;\r\n    border: none;\r\n    padding: 4px 8px;\r\n    border-radius: 4px;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n}\r\n\r\n.btn-send:hover {\r\n    background: #2f855a;\r\n}\r\n\r\n.btn-dismiss:hover {\r\n    background: #e2e8f0;\r\n}\r\n\r\n.btn-customize {\r\n    background: #ebf8ff;\r\n    color: #2b6cb0;\r\n    border: 1px solid #bee3f8;\r\n    padding: 4px 7px;\r\n    border-radius: 4px;\r\n    font-size: 12px;\r\n    cursor: pointer;\r\n    line-height: 1;\r\n}\r\n.btn-customize:hover {\r\n    background: #bee3f8;\r\n}\r\n\r\n/* Gantt Today Marker */\r\n.gantt-today-marker {\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    width: 2px;\r\n    background-color: #e53e3e;\r\n    z-index: 50;\r\n    pointer-events: none;\r\n    box-shadow: 0 0 4px rgba(229, 62, 62, 0.4);\r\n}\r\n\r\n.gantt-today-badge {\r\n    position: absolute;\r\n    top: -24px;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    background: #e53e3e;\r\n    color: white;\r\n    font-size: 10px;\r\n    font-weight: bold;\r\n    padding: 2px 6px;\r\n    border-radius: 4px;\r\n    white-space: nowrap;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.gantt-today-badge::after {\r\n    content: '';\r\n    position: absolute;\r\n    bottom: -4px;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    border-left: 4px solid transparent;\r\n    border-right: 4px solid transparent;\r\n    border-top: 4px solid #e53e3e;\r\n}\r\n\r\n/* Modal uniforme (estilo nota encomenda) */\r\n.modal-ef { background: white; border-radius: 16px; padding: 28px; max-width: 500px; width: 95%; box-shadow: 0 20px 25px rgba(0,0,0,0.15); }\r\n.modal-ef-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; padding-bottom: 14px; border-bottom: 1px solid #e2e8f0; }\r\n.modal-ef-num { font-weight: 700; font-size: 16px; color: #1e293b; }\r\n.modal-close { background: none; border: none; font-size: 28px; line-height: 1; cursor: pointer; color: #64748b; padding: 4px; width: 36px; height: 36px; display: flex; align-items: center; justify-content: center; border-radius: 8px; transition: all 0.15s; }\r\n.modal-close:hover { color: #1e293b; background: #f1f5f9; }\r\n.modal-form-body { padding: 4px 0 0; }\r\n.modal-form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 16px; }\r\n.modal-field { display: flex; flex-direction: column; gap: 4px; }\r\n.modal-field.full { grid-column: 1 / -1; }\r\n.modal-field label { font-size: 10px; font-weight: 700; color: #888; text-transform: uppercase; letter-spacing: 0.4px; }\r\n.modal-field input, .modal-field textarea, .modal-field select { padding: 9px 12px; border: 1px solid #e2e8f0; border-radius: 8px; font-family: inherit; font-size: 13px; transition: border-color 0.15s; }\r\n.modal-field input:focus, .modal-field textarea:focus, .modal-field select:focus { outline: none; border-color: #5b4fcf; box-shadow: 0 0 0 3px rgba(91,79,207,0.08); }\r\n.modal-form-actions { display: flex; justify-content: flex-end; gap: 8px; padding-top: 16px; border-top: 1px solid #e2e8f0; margin-top: 8px; }\r\n.btn-modal-cancel { padding: 10px 20px; background: #f3f4f6; border: 1px solid #dde1e7; border-radius: 8px; cursor: pointer; font-size: 13px; font-weight: 600; min-height: 38px; display: inline-flex; align-items: center; gap: 6px; transition: all 0.15s; }\r\n.btn-modal-cancel:hover { background: #e5e7eb; }\r\n.btn-modal-save { padding: 10px 20px; background: #3182ce; color: white; border: none; border-radius: 8px; cursor: pointer; font-size: 13px; font-weight: 600; min-height: 38px; display: inline-flex; align-items: center; gap: 6px; transition: all 0.15s; }\r\n.btn-modal-save:hover:not(:disabled) { background: #2b6cb0; }\r\n.btn-modal-save:disabled { opacity: 0.6; cursor: not-allowed; }\r\n/* Splitter arrastável entre Gantt e painel de trabalhadores */\r\n.trab-panel-splitter {\r\n    height: 10px;\r\n    margin: 4px 0 -2px 0;\r\n    cursor: row-resize;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    user-select: none;\r\n}\r\n.trab-panel-splitter-handle {\r\n    width: 60px;\r\n    height: 4px;\r\n    background: #cbd5e0;\r\n    border-radius: 2px;\r\n    transition: background 0.15s;\r\n}\r\n.trab-panel-splitter:hover .trab-panel-splitter-handle { background: #3182ce; }\r\n.trab-panel-splitter:active .trab-panel-splitter-handle { background: #2b6cb0; }\r\n\r\n/* Painel de Trabalhadores (drag & drop para o Gantt) */\r\n.trab-panel {\r\n    margin-top: 10px;\r\n    background: white;\r\n    border: 1px solid #e2e8f0;\r\n    border-radius: 10px;\r\n    padding: 8px 12px;\r\n    box-shadow: 0 1px 3px rgba(0,0,0,0.04);\r\n    display: flex;\r\n    flex-direction: column;\r\n    min-height: 120px;\r\n    overflow: hidden;\r\n}\r\n.trab-panel-header {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    margin-bottom: 6px;\r\n    padding-bottom: 6px;\r\n    border-bottom: 1px solid #edf2f7;\r\n    flex-wrap: wrap;\r\n}\r\n.trab-panel-header strong { color: #2d3748; font-size: 13px; }\r\n.trab-panel-hint { color: #94a3b8; font-size: 11px; font-style: italic; margin-left: auto; }\r\n.trab-week-selector {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 4px;\r\n    background: #f1f5f9;\r\n    border-radius: 6px;\r\n    padding: 2px 4px;\r\n}\r\n.trab-week-selector button {\r\n    background: white;\r\n    border: 1px solid #cbd5e0;\r\n    border-radius: 4px;\r\n    padding: 2px 8px;\r\n    font-size: 11px;\r\n    cursor: pointer;\r\n    color: #2d3748;\r\n    transition: all 0.15s;\r\n}\r\n.trab-week-selector button:hover { background: #ebf8ff; border-color: #3182ce; }\r\n.trab-week-label { font-size: 12px; font-weight: 600; color: #2d3748; padding: 0 6px; min-width: 130px; text-align: center; }\r\n.trab-week-today { background: #3182ce !important; color: white !important; border-color: #3182ce !important; font-weight: 600; }\r\n.trab-week-today:hover { background: #2b6cb0 !important; }\r\n\r\n.trab-panel-grupos {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 8px;\r\n    flex: 1;\r\n    min-height: 0;\r\n    overflow: hidden;\r\n}\r\n.trab-panel-grupo {\r\n    background: #fafbfc;\r\n    border: 1px solid #edf2f7;\r\n    border-radius: 6px;\r\n    padding: 6px 8px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    min-height: 0;\r\n    overflow: hidden;\r\n}\r\n.trab-grupo-label {\r\n    display: inline-block;\r\n    font-size: 10px;\r\n    font-weight: 700;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.4px;\r\n    margin-bottom: 4px;\r\n}\r\n.trab-grupo-label.livre { color: #38a169; }\r\n.trab-grupo-label.atribuido { color: #3182ce; }\r\n.trab-empty { color: #cbd5e0; font-size: 11px; }\r\n\r\n.trab-panel-list {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-content: flex-start;\r\n    gap: 4px;\r\n    flex: 1;\r\n    min-height: 0;\r\n    overflow-y: auto;\r\n}\r\n.trab-chip {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 5px;\r\n    padding: 2px 8px 2px 2px;\r\n    background: #f8fafc;\r\n    border: 1px solid #cbd5e0;\r\n    border-radius: 14px;\r\n    cursor: grab;\r\n    user-select: none;\r\n    transition: all 0.15s;\r\n    font-size: 11px;\r\n    line-height: 1;\r\n}\r\n.trab-chip:hover { background: #ebf8ff; border-color: #3182ce; transform: translateY(-1px); }\r\n.trab-chip:active, .trab-chip.dragging { cursor: grabbing; opacity: 0.5; transform: scale(0.95); }\r\n.trab-chip.atribuido { background: #ebf8ff; border-color: #90cdf4; }\r\n.trab-chip.atribuido .trab-chip-iniciais { background: #2c5282; }\r\n.trab-chip.livre .trab-chip-iniciais { background: #38a169; }\r\n.trab-chip-iniciais {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    min-width: 22px;\r\n    height: 18px;\r\n    padding: 0 5px;\r\n    background: #3182ce;\r\n    color: white;\r\n    border-radius: 10px;\r\n    font-weight: 700;\r\n    font-size: 9px;\r\n}\r\n.trab-chip-nome { color: #2d3748; font-weight: 500; font-size: 11px; }\r\n/* Alocado a uma obra fora do filtro atual (ex.: concluída) — não aparece no Gantt visível */\r\n.trab-chip.fora-vista { background: #fffbeb; border-color: #f59e0b; }\r\n.trab-chip.fora-vista .trab-chip-iniciais { background: #b45309; }\r\n.trab-chip-flag { color: #b45309; font-size: 11px; margin-left: 1px; cursor: help; }\r\n\r\n/* Iniciais dentro da barra do Gantt — agrupadas por semana, posicionadas no offset correcto */\r\n.gantt-bar-iniciais-grupo {\r\n    position: absolute;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    display: inline-flex;\r\n    gap: 2px;\r\n    align-items: center;\r\n    z-index: 5;\r\n    width: auto;\r\n    white-space: nowrap;\r\n    /* Confina os crachás à largura da própria semana para não invadirem a seguinte */\r\n    overflow: hidden;\r\n}\r\n/* Indicador \"+N\" para os trabalhadores que não cabem na largura da semana */\r\n.trab-inicial-mais {\r\n    background: rgba(0, 0, 0, 0.55) !important;\r\n    color: #fff !important;\r\n    border-color: rgba(0, 0, 0, 0.2) !important;\r\n    cursor: default;\r\n    flex-shrink: 0;\r\n}\r\n.trab-inicial-mais:hover {\r\n    background: rgba(0, 0, 0, 0.7) !important;\r\n    color: #fff !important;\r\n    transform: none;\r\n}\r\n.trab-inicial-chip {\r\n    padding: 0 5px;\r\n    height: 16px;\r\n    line-height: 16px;\r\n    font-size: 9px;\r\n    font-weight: 700;\r\n    border-radius: 8px;\r\n}\r\n.trab-inicial-chip {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 1px 6px;\r\n    background: rgba(255,255,255,0.95);\r\n    color: #1a202c;\r\n    border-radius: 10px;\r\n    font-size: 10px;\r\n    font-weight: 700;\r\n    cursor: pointer;\r\n    border: 1px solid rgba(0,0,0,0.1);\r\n    white-space: nowrap;\r\n    transition: all 0.15s;\r\n}\r\n.trab-inicial-chip:hover { background: #fed7d7; color: #c53030; transform: scale(1.05); }\r\n\r\n/* Highlight da barra quando se arrasta um trabalhador por cima */\r\n.gantt-bar-obra.drag-over { outline: 2px dashed #38a169; outline-offset: -2px; }\r\n\n/* Pesquisa e localização: os resultados são as próprias linhas do calendário. */\n.planeamento-container .planeamento-search { flex: 1 1 380px; max-width: 560px; min-width: 0; }\n.planeamento-search > label { display: block; margin-bottom: 5px; font-size: 12px; font-weight: 600; }\n.planeamento-container .planeamento-search-controls { display: flex; align-items: center; gap: 6px; margin-bottom: 0; }\n.planeamento-container .planeamento-search-controls input { flex: 1; min-width: 0; width: 100%; padding: 8px 10px; font: inherit; }\n.planeamento-search-controls button { flex-shrink: 0; white-space: nowrap; cursor: pointer; }\n.planeamento-search-controls button:disabled { opacity: .55; cursor: not-allowed; }\n.planeamento-search-status { display: block; min-height: 30px; margin-top: 4px; font-size: 11px; line-height: 15px; }\n.planeamento-container .gantt-obra-location { width: 100%; border-top: 0; border-left: 0; border-right: 0; border-radius: 0; background: transparent; color: inherit; font-family: inherit; text-align: left; cursor: pointer; }\n.planeamento-container .gantt-obra-location:hover { background-color: #d9eaff88; }\n.planeamento-container .gantt-obra-location:focus-visible { outline: 2px solid #367ab9; outline-offset: -3px; }\n.planeamento-container .gantt-row-label.obra-localizada,\n.planeamento-container .gantt-row-content.obra-localizada { background-color: #3182ce20; box-shadow: inset 3px 0 #3182ce; }\n.planeamento-search input:focus-visible { outline: 2px solid #367ab9; outline-offset: 2px; }\n@media (max-width: 600px) {\n    .planeamento-container .planeamento-search { flex-basis: 100%; max-width: none; }\n    .planeamento-container .planeamento-search-controls { flex-wrap: wrap; }\n    .planeamento-container .planeamento-search-controls input { flex-basis: 100%; }\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
